<template>
  <div class="section">
    <div class="beer-foam"></div>

    <div class="section-footer">
      <b-container>
        <b-row class="mt-5 text-center" cols="1" cols-sm="1" cols-md="3" cols-lg="3">
          <b-col class="d-flex justify-content-center align-items-center">
            <p>
              <img src="./../assets/logo-albnegru.png" alt class="logo-albnegru" />
            </p>
          </b-col>

          <b-col class="justify-content-center align-items-center">
            <p class="mb-0 font-weight-bold">MUSTAȚA DE BERE®</p>
            <p>Brașov, România</p>
            <p class="mb-0">Telefon: 0799 976 596</p>
            <p>E-mail: beremustata@gmail.com</p>
          </b-col>

          <b-col class="d-flex justify-content-center align-items-center">
            <span class="mb-0">
              <a href="https://www.facebook.com/mustatadebere/" target="_blank">
                <img :src="FacebookLogo" class="contact facebook" />
              </a>
              <a href="https://www.instagram.com/mustatadebere/" target="_blank">
                <img :src="InstagramLogo" class="contact" />
              </a>
            </span>
          </b-col>
        </b-row>
        <b-row class="credits mt-3">
          <span>
            Proudly made by
            <a
              href="https://raluca.marin.rocks/"
              target="_blank"
            >
              <img src="../assets/signature-raluca.gif" alt class="credits" />
            </a>
          </span>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import FacebookLogo from "./../assets/facebook.svg";
import InstagramLogo from "./../assets/instagram.svg";

export default {
  name: "Footer",

  computed: {
    FacebookLogo() {
      return FacebookLogo;
    },
    InstagramLogo() {
      return InstagramLogo;
    }
  }
};
</script>

<style>
.section-footer {
  background-image: url("./../assets/asfalt-light.png"), url("./../assets/asfalt-light.png"), url("./../assets/asfalt-light.png");
  background-color: #f4ad33;
  color: black;
  padding: 25px 0px;
  font-size: 14px;
  perspective: 1000px;
  perspective-origin: 50% 50%;
  animation: animation 100s linear infinite;
}

@keyframes animation {
  100% {
    background-position: 0px -3000px;
  }
}

.beer-foam {
  background-image: url("./../assets/beer-foam-2.png");
  background-repeat: repeat-x;
  min-height: 100px;
  background-position: center top;
  background-size: contain;
  position: relative;
  margin-bottom: -50px;
  z-index: 100;
}

.contact {
  width: 30px;
  margin: 0 5px;
}

.credits {
  justify-content: center;
  height: 25px;
}

.credits span {
  font-size: 12px;
}

.logo-albnegru {
  width: 100px;
  height: 100px;
}
</style>
